import './App.css';
import ImageCompresser from './components/ImageCompresser';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ImageEditor from './components/ImageEditor';
import Navbar from './components/Navbar';
import { Toaster } from 'react-hot-toast';
import Homepage from './components/Homepage';
import { ThemeProvider, createTheme } from '@mui/material';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Poppins',
    ].join(','),
  },
});


function App() {
  return (
    <>
    <ThemeProvider theme={theme}>
      <Router>
        <Navbar/>
        <Routes>
          <Route path='/' element={<Homepage/>}></Route>
          <Route path='/image-compresser' element={<ImageCompresser/>}></Route>
          <Route path='/image-editor' element={<ImageEditor/>}></Route>
        </Routes>
      </Router>
      <Toaster
        position="bottom-center"
        reverseOrder={false}
      />
    </ThemeProvider>
    </>

  );
}

export default App;
